/* eslint-disable i18next/no-literal-string */
export function getEnvironment() {
  const [environment = ''] = window.location.hostname.split('.');

  return environment === 'demo' ? 'live' : 'stg';
}
